import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { Winner } from '../model/winner';

@Injectable()
export class RodeoEventService {
    constructor(private api: ApiService) { }

    getEventTypes() {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.rodeoEvents + '/getEventTypes')
                .then(data => resolve(data), error => reject(error));
        });
    }

    getRodeoEvent(rodeoEventId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.rodeoEvents + '/get?id=' + rodeoEventId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateRodeoEvent(data: any) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(this.api.endpoints.rodeoEvents + '/update?id=' + data.id, data)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateRodeoLeadersCast(rodeoEventId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.rodeoEvents + '/updateRodeoLeadersCast?id=' + rodeoEventId)
                .then(data => resolve(data), error => reject(error));
        });
    }
    
    deleteRodeoEvent(rodeoEventId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .deleteWithAuth(this.api.endpoints.rodeoEvents + '/delete?id=' + rodeoEventId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getAllForRodeo(rodeoId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.rodeoEvents + '/getAllForRodeo?rodeoId=' + rodeoId)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/rodeoEvent.service.ts